import styled from "styled-components";

const DurationDisplayStyled = styled.div`
  display: flex;
  padding: 5px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
`;

export default DurationDisplayStyled;
